import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { path } from 'ramda';
import { useLocation } from 'react-router-dom';
import { isExternalUrl } from 'js/utils/url.util';
import { kambiNavigate } from '../../../utils/url.utils';
import { MY_ACCOUNT_SIDEBAR_REDUCER } from 'js/store/constants';
import { Link as CoreLink } from 'js/components/common/Link/Link';
import { useGetPageRoutingURL } from '../../../hooks/useGetPageRoutingURL';
import { useHandleSidebarClose } from 'js/components/main/MyAccountSidebar/hooks';

export const Link = (props) => {
    const { href, onClick, inNewWindow, ...other } = props;

    const location = useLocation();
    const linkPath = useGetPageRoutingURL(href);
    const closeSidebar = useHandleSidebarClose();
    const isSidebarOpen = useSelector(path([MY_ACCOUNT_SIDEBAR_REDUCER, 'isOpened']));

    const onLinkClick = useCallback((event) => {
        onClick?.(event);

        if (isSidebarOpen && `${location.pathname}${location.hash}` === linkPath) {
            closeSidebar();
        }

        if (/\/kambi#/.test(linkPath)) {
            kambiNavigate(linkPath);
        }
    }, [location.pathname, location.hash, linkPath, isSidebarOpen, onClick, closeSidebar]);

    const target = inNewWindow || isExternalUrl(href) ? '_blank' : '_self';

    return <CoreLink href={href} onClick={onLinkClick} inNewWindow={inNewWindow} target={target} {...other} />;
};
